import { useQuery } from "react-query";
import SchemaService from "../api/services/SchemaService";

export const useGetBondApplicantFormSchema = (queryKey: string) => {
  const { data, isLoading, refetch, isError, error } = useQuery(
    queryKey,
    async () => await SchemaService.getBondApplicantForm()
  );

  return {
    bondAppSchema: data?.data?.schema,
    isBondAppSchemaLoading: isLoading,
    bondAppSchemaError: error,
    isBondAppSchemaError: isError,
    fetchBondAppSchema: refetch,
  };
};
